var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Block, getTypesetDOMStyle, parseTypesetStyle, SylController, SylPlugin } from '@syllepsis/adapter';
import { Fragment, Slice } from 'prosemirror-model';
import { addAttrsByConfig, constructTypesetParseDOM, getFromDOMByConfig, setDOMAttrByConfig, } from '../../utils';
import { LIST_ITEM_NAME } from './const';
import { checkAndMergeList, checkOutMaxNestedLevel, filterKeymap, getListItem, liftListItem, liftListItemAtHead, sinkListItem, splitListItemKeepMarks, } from './utils';
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.formatAttrs = function (v) { return v; };
        _this.defaultFontSize = 16;
        _this.toDOMAttrs = {};
        _this.name = LIST_ITEM_NAME;
        _this.tagName = function () { return 'li'; };
        _this.attrs = {
            align: {
                default: '',
            },
            spaceBefore: {
                default: '',
            },
            spaceAfter: {
                default: '',
            },
            spaceBoth: {
                default: '',
            },
            lineHeight: {
                default: '',
            },
        };
        _this.inline = false;
        _this.defining = false;
        _this.parseDOM = [
            {
                tag: 'li',
                priority: 25,
                getAttrs: function (dom) {
                    if (dom.tagName.toUpperCase() === 'LI' && _this.props.matchInnerTags && _this.props.matchInnerTags.length) {
                        var childNode = dom.querySelector(_this.props.matchInnerTags.join(','));
                        if (childNode)
                            return false;
                    }
                    var style = dom.getAttribute('style') || '';
                    return _this.formatAttrs(parseTypesetStyle(style, undefined, _this.defaultFontSize), dom);
                },
            },
        ];
        _this.toDOM = function (node) {
            var attrs = {};
            var nodeAttrs = __assign({}, node.attrs);
            var style = getTypesetDOMStyle(_this.formatAttrs(nodeAttrs), _this.toDOMAttrs);
            style && (attrs.style = style);
            var align = nodeAttrs.align;
            if (align && !'left justify'.includes(align)) {
                attrs.style = style + "list-style-position: inside;";
            }
            setDOMAttrByConfig(_this.props.addAttributes, node, attrs);
            return ['li', attrs, 0];
        };
        if (props) {
            addAttrsByConfig(props.addAttributes, _this);
            _this.constructParseDOM(props);
        }
        return _this;
    }
    ListItem.prototype.constructParseDOM = function (config) {
        var _this = this;
        var _a = constructTypesetParseDOM(config), defaultFontSize = _a.defaultFontSize, formatAttrs = _a.formatAttrs, defaultAttrs = _a.defaultAttrs;
        this.toDOMAttrs = __assign(__assign({}, this.attrs), defaultAttrs);
        var parseRule = this.parseDOM[0];
        this.defaultFontSize = +defaultFontSize || 16;
        this.formatAttrs = function (attrs, dom) {
            var formattedAttrs = formatAttrs(attrs, dom);
            dom && getFromDOMByConfig(config.addAttributes, dom, formattedAttrs);
            return formattedAttrs;
        };
        if (config.matchInnerTags) {
            config.matchInnerTags.forEach(function (tagName) {
                _this.parseDOM.push(__assign(__assign({}, parseRule), { tag: tagName, priority: 30, getAttrs: function (dom) {
                        var parentElement = dom.parentElement;
                        var style = dom.getAttribute('style') || '';
                        var matchList = false;
                        while (parentElement) {
                            style = parentElement.getAttribute('style') || '' + style;
                            if (parentElement.tagName.toUpperCase() === 'LI') {
                                matchList = true;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        if (!matchList)
                            return false;
                        dom.setAttribute('style', style);
                        return parseRule.getAttrs(dom);
                    } }));
            });
        }
    };
    return ListItem;
}(Block));
var ListItemController = /** @class */ (function (_super) {
    __extends(ListItemController, _super);
    function ListItemController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = LIST_ITEM_NAME;
        _this.eventHandler = {
            transformPasted: function (editor, slice) {
                var $from = editor.view.state.selection.$from;
                if ($from.parent.type.name === LIST_ITEM_NAME && $from.pos === $from.start()) {
                    // hack when paste at start of list_item
                    var listNode = getListItem(slice);
                    if (!listNode)
                        return slice;
                    slice.openStart += 1;
                    if (!slice.size)
                        return new Slice(Fragment.from(listNode), 1, 1);
                }
                return slice;
            },
        };
        _this.command = {
            getMaxNestedLevel: function () { return _this.props.maxNestedLevel; },
            setMaxNestedLevel: function (editor, level) { return (_this.props.maxNestedLevel = level); },
            liftItem: function (editor) { return liftListItem(editor.view.state, editor.view.dispatch); },
            sinkItem: function (editor) { return sinkListItem(editor.view.state, editor.view.dispatch); },
        };
        _this.keymap = {
            Enter: filterKeymap(splitListItemKeepMarks),
            'Shift-Tab': filterKeymap(liftListItem),
            Tab: function (editor, state, dispatch) {
                return sinkListItem(state, dispatch, function () { return checkOutMaxNestedLevel(state, _this.props.maxNestedLevel); });
            },
            Backspace: filterKeymap(liftListItemAtHead),
        };
        _this.appendTransaction = function (tr) {
            var isMerged = checkAndMergeList(tr, tr.selection.$from.after(1));
            if (isMerged)
                return tr;
        };
        return _this;
    }
    return ListItemController;
}(SylController));
var ListItemPlugin = /** @class */ (function (_super) {
    __extends(ListItemPlugin, _super);
    function ListItemPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = LIST_ITEM_NAME;
        _this.Controller = ListItemController;
        _this.Schema = ListItem;
        return _this;
    }
    return ListItemPlugin;
}(SylPlugin));
export { LIST_ITEM_NAME, ListItem, ListItemController, ListItemPlugin };
//# sourceMappingURL=index.js.map